module.exports = __webpack_public_path__ + "static/media/home_slide1.707061cb.jpg";